import Help from "../components/help/index";
import Layout from '../components/layouts/allpagelayout';
const HelpPage = () => {
  return (
    <Layout>
      <Help />
    </Layout>
  );
}
export default HelpPage;